 import React, {useEffect, useReducer, useState} from 'react'
import DashboardFooter from '../../layouts/dashboard_footer';
import DashboardHeader from "../../layouts/dashboard_header";
import SideMenu from "../../layouts/dashboard_menu";
import {useUserNames, useBaseUrl} from "../../../utils/utils";
import {useNavigate} from "react-router-dom";
import Canvas from "../../layouts/dahboard_canvas";
import TelehealthInterface from "../Collaborations/TelehealthInterface";
import DocumentManagement from "../Collaborations/DocumentManagement";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faVideo, faPhone, faComments, faCalendarAlt, 
    faFileMedical, faUsers, faHeartbeat, faMicrophone,
    faDesktop, faWifi, faSignal, faVolumeUp, faVolumeMute,
    faVideoSlash, faCog, faExpand, faCompress
} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Swal from 'sweetalert2';

const CommunicationHome: React.FC = () => {

    const navigate = useNavigate()
    const baseUrl = useBaseUrl();
    const [activeCollaboration, setActiveCollaboration] = useState<string | null>(null);
    const [activeTelehealthSession, setActiveTelehealthSession] = useState<string | null>(null);
    const [collaborations, setCollaborations] = useState<any[]>([]);
    const [telehealthSessions, setTelehealthSessions] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    let user_info: any = {first_name: "", last_name: "", clinic: "", staff_id: "", avatar: ""}

    useEffect(()=>{

        document.title = "Enhanced Telehealth Center"

        const GetUsers = async () => {

            const user_info = useUserNames()

        }

        user_info = GetUsers()
        fetchCollaborations();
        fetchTelehealthSessions();

    }, [baseUrl])

    const fetchCollaborations = async () => {
        try {
            const response = await axios.get(`${baseUrl}collaborations/collaborations/`);
            if (response.data.status === 'success') {
                setCollaborations(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching collaborations:', error);
        }
    };

    const fetchTelehealthSessions = async () => {
        try {
            const response = await axios.get(`${baseUrl}collaborations/telehealth-sessions/`);
            if (response.data.status === 'success') {
                setTelehealthSessions(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching telehealth sessions:', error);
        }
    };

    const startTelehealthSession = async (collaborationId: string) => {
        try {
            setLoading(true);
            const sessionData = {
                collaboration_id: collaborationId,
                title: `Telehealth Session for Collaboration`,
                session_type: 'video',
                scheduled_time: new Date().toISOString(),
                duration: 60,
                recording_enabled: false
            };

            const response = await axios.post(`${baseUrl}collaborations/telehealth-sessions/`, sessionData);
            
            if (response.data.status === 'success') {
                setActiveTelehealthSession(response.data.session_id);
                setActiveCollaboration(collaborationId);
                dispatch({type: "SET_STEP", payload: 6}); // New step for telehealth
                Swal.fire({
                    icon: 'success',
                    title: 'Session Started',
                    text: 'Telehealth session initiated successfully!'
                });
            }
        } catch (error) {
            console.error('Error starting session:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to start telehealth session'
            });
        } finally {
            setLoading(false);
        }
    };

    const initialState = {
        step: 0,
        subStep: 0,
        cardStep: 0,
        header: "Enhanced Uzima Telehealth Center",
        subHeader: "Access all collaboration communications, telehealth sessions, and documents from one place.",
        showHeadings: true,
        partnerOrPatient: "patient",
        selectedCollaboration: null,
        activeTelehealthSession: null
    }

    const reducer = (state: any, action: any) => {

        switch(action.type){

            case 'SET_STEP':
                return {...state, step: action.payload}

            case 'SET_PAGE_HEADING':
                return {...state, header: action.payload}

            case 'SET_SUB_HEADER':
                return {...state, subHeader: action.payload}

            case 'SET_SUB_STEP':
                return {...state, subStep: action.payload}

            case 'SET_CARD_STEP':
                return {...state, cardStep: action.payload}

            case 'SET_SHOW_HEADINGS':
                return {...state, showHeadings: action.payload}

            case 'SET_PARTNER_OR_PATIENT':
                return{...state, partnerOrPatient: action.payload}

            case 'SET_SELECTED_COLLABORATION':
                return {...state, selectedCollaboration: action.payload}

            case 'SET_ACTIVE_TELEHEALTH_SESSION':
                return {...state, activeTelehealthSession: action.payload}

            case 'SET_DATE':
                return {...state, date: action.payload}

            case 'SET_MEETING_TITLE':
                return {...state, meetingTitle: action.payload}

            case 'SET_MEETING_DESC':
                return {...state, meetingDesc: action.payload}

            default:
                return state
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState)

    return (
        <>
            <DashboardHeader />
            <SideMenu />
            <div className={"vertical-overlay"} />
            <div className={"main-content"}>
                <div className={"page-content"}>

                    <div className={'container-fluid'}>

                        {state.showHeadings && (
                            <>
                                <div className={"row mt-4 text-center"}>
                                    <div className={"col-12"}>
                                        <h3>{state.header}</h3>
                                    </div>
                                </div>

                                <div className={"row mt-4 text-center"}>
                                    <div className={"col"}>
                                        <h6>{state.subHeader}</h6>
                                    </div>
                                </div>
                            </>
                        )}

                        {state.step === 0 && (
                            <>
                                {/* Enhanced Collaboration Communications Section */}
                                <div className={"row mt-4"}>
                                    <div className={"col-12"}>
                                        <div className="card border-primary">
                                            <div className="card-header bg-primary text-white">
                                                <h5 className="mb-0">
                                                    <FontAwesomeIcon icon={faHeartbeat} className="me-2" />
                                                    Active Collaborations - Telehealth Access
                                                </h5>
                                            </div>
                                            <div className="card-body">
                                                {collaborations.length > 0 ? (
                                                    <div className="row">
                                                        {collaborations.slice(0, 6).map((collaboration) => (
                                                            <div key={collaboration.collaboration_id} className="col-md-4 mb-3">
                                                                <div className="card border-info h-100">
                                                                    <div className="card-body">
                                                                        <h6 className="card-title text-primary">{collaboration.title}</h6>
                                                                        <p className="card-text small">{collaboration.patient?.name}</p>
                                                                        <p className="text-muted small">
                                                                            Status: <span className="badge bg-success">{collaboration.status}</span>
                                                                        </p>
                                                                        <div className="d-flex gap-2">
                                                                            <button 
                                                                                className="btn btn-primary btn-sm"
                                                                                onClick={() => startTelehealthSession(collaboration.collaboration_id)}
                                                                                disabled={loading}
                                                                            >
                                                                                <FontAwesomeIcon icon={faVideo} className="me-1" />
                                                                                Start Video
                                                                            </button>
                                                                            <button 
                                                                                className="btn btn-outline-primary btn-sm"
                                                                                onClick={() => {
                                                                                    setActiveCollaboration(collaboration.collaboration_id);
                                                                                    dispatch({type: "SET_STEP", payload: 7}); // Documents step
                                                                                }}
                                                                            >
                                                                                <FontAwesomeIcon icon={faFileMedical} className="me-1" />
                                                                                Docs
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <div className="text-center py-4">
                                                        <FontAwesomeIcon icon={faUsers} size="3x" className="text-muted mb-3" />
                                                        <p className="text-muted">No active collaborations found. Start a collaboration to access telehealth features.</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={"row mt-4"}>

                                    <div className={"col"}>

                                        <div className={"card card-animate"} onClick={(e)=>{
                                            dispatch({type: "SET_SUB_HEADER", payload: "Non Specific Communication"})
                                            dispatch({type: "SET_STEP", payload: 1})
                                        }} >

                                            <div className="card-body p-4 text-center">
                                                <br />
                                                <br />
                                                <div className="mx-auto avatar-md mb-3">
                                                    <FontAwesomeIcon icon={faComments} size="2x" className="text-primary" />
                                                </div>
                                                <br />
                                                <h5 className="card-title mb-1">General Communication</h5>

                                                <br />

                                            </div>

                                        </div>


                                    </div>

                                    <div className={"col"}>

                                        <div className={"card card-animate"} onClick={(e)=>{
                                            dispatch({type: "SET_SUB_HEADER", payload: "View Communications specific to a partner or patient"})
                                            dispatch({type: "SET_STEP", payload: 2})
                                        }} >

                                            <div className="card-body p-4 text-center">
                                                <br />
                                                <br />
                                                <div className="mx-auto avatar-md mb-3">
                                                    <FontAwesomeIcon icon={faUsers} size="2x" className="text-success" />
                                                </div>
                                                <br />
                                                <h5 className="card-title mb-1">Targeted Communication</h5>

                                                <br />

                                            </div>

                                        </div>


                                    </div>

                                    <div className={"col"}>

                                        <div className={"card card-animate"} onClick={(e)=>{
                                            dispatch({type: "SET_SUB_HEADER", payload: "Access enhanced telehealth features"})
                                            dispatch({type: "SET_STEP", payload: 8}) // New enhanced telehealth step
                                        }} >

                                            <div className="card-body p-4 text-center">
                                                <br />
                                                <br />
                                                <div className="mx-auto avatar-md mb-3">
                                                    <FontAwesomeIcon icon={faHeartbeat} size="2x" className="text-danger" />
                                                </div>
                                                <br />
                                                <h5 className="card-title mb-1">Enhanced Telehealth</h5>

                                                <br />

                                            </div>

                                        </div>


                                    </div>

                                </div>

                            </>
                        )}

                        {state.step === 1 && (
                            <>
                                {state.subStep === 0 && (
                                    <>
                                        <div className={"row mt-4"}>

                                            <div className={"col-md-3"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima General Appointments"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 1})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/planners.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Appointments</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>

                                            <div className={"col-md-3"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima General Meetings"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 2})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/meetings.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Meetings</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>

                                            <div className={"col-md-3"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima General Chats"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 3})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/messaging.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Chats</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>

                                            <div className={"col-md-3"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima General Notifications"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 4})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/notifications.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Notifications</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>

                                            <div className={"col-md-3"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima General Messages"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 5})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/unopened.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Messaging</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>

                                            <div className={"col-md-3"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima General Documents Manager"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 1})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/notes.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Document Manager</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>

                                            <div className={"col-md-3"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima Healthcare Communications Center"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 0})
                                                    dispatch({type: "SET_STEP", payload: 0})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/back.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Go Back</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>

                                        </div>
                                    </>
                                )}

                                {state.subStep === 1 && (
                                    <>

                                    </>
                                )}

                                {state.subStep === 2 && (
                                    <>
                                        <div className={"row mt-4"}>
                                                <div className={"col-md-3"}>

                                                    <div className={"card card-animate"} onClick={(e)=>{
                                                        dispatch({type: "SET_SUB_HEADER", payload: "Create an open / genera meeting"})
                                                        dispatch({type: "SET_STEP", payload: 3})
                                                    }} >

                                                        <div className="card-body p-4 text-center">
                                                            <br />
                                                            <br />
                                                            <div className="mx-auto avatar-md mb-3">
                                                                <img
                                                                    src={`${process.env.PUBLIC_URL}/assets/images/meetings.png`}
                                                                    alt=""
                                                                    className="img-fluid "
                                                                />
                                                            </div>
                                                            <br />
                                                            <h5 className="card-title mb-1">Create Meeting</h5>

                                                            <br />

                                                        </div>

                                                    </div>

                                                </div>

                                                <div className={"col-md-3"}>

                                                    <div className={"card card-animate"} onClick={(e)=>{
                                                        dispatch({type: "SET_SUB_HEADER", payload: "Your upcoming meetings (allowed maximum: 15)"})
                                                        dispatch({type: "SET_STEP", payload: 4})
                                                    }} >

                                                        <div className="card-body p-4 text-center">
                                                            <br />
                                                            <br />
                                                            <div className="mx-auto avatar-md mb-3">
                                                                <img
                                                                    src={`${process.env.PUBLIC_URL}/assets/images/meeting.png`}
                                                                    alt=""
                                                                    className="img-fluid"
                                                                />
                                                            </div>
                                                            <br />
                                                            <h5 className="card-title mb-1">Upcoming Meetings</h5>

                                                            <br />

                                                        </div>

                                                    </div>

                                                </div>

                                                <div className={"col-md-3"}>

                                                    <div className={"card card-animate"} onClick={(e)=>{
                                                        dispatch({type: "SET_SUB_HEADER", payload: "Your meeting history (showing for the last 15 days max)"})
                                                        dispatch({type: "SET_STEP", payload: 5})
                                                    }} >

                                                        <div className="card-body p-4 text-center">
                                                            <br />
                                                            <br />
                                                            <div className="mx-auto avatar-md mb-3">
                                                                <img
                                                                    src={`${process.env.PUBLIC_URL}/assets/images/api.png`}
                                                                    alt=""
                                                                    className="img-fluid"
                                                                />
                                                            </div>
                                                            <br />
                                                            <h5 className="card-title mb-1">Meeting History</h5>

                                                            <br />

                                                        </div>

                                                    </div>

                                                </div>

                                                <div className={"col-md-3"}>

                                                    <div className={"card card-animate"} onClick={(e)=>{
                                                        dispatch({type: "SET_SUB_HEADER", payload: "Uzima Healthcare Communications Center"})
                                                        dispatch({type: "SET_SUB_STEP", payload: 0})
                                                        dispatch({type: "SET_STEP", payload: 0})
                                                    }} >

                                                        <div className="card-body p-4 text-center">
                                                            <br />
                                                            <br />
                                                            <div className="mx-auto avatar-md mb-3">
                                                                <img
                                                                    src={`${process.env.PUBLIC_URL}/assets/images/back.png`}
                                                                    alt=""
                                                                    className="img-fluid"
                                                                />
                                                            </div>
                                                            <br />
                                                            <h5 className="card-title mb-1">Go Back</h5>

                                                            <br />

                                                        </div>

                                                    </div>


                                                </div>

                                        </div>
                                    </>
                                )}


                            </>
                        )}

                        {state.step === 2 && (
                            <>
                                {state.subStep === 0 && (
                                    <>
                                        <div className={"row mt-4"}> </div>
                                        <div className={"row mt-4"}> </div>
                                        <div className={"row mt-4"}>

                                            <div className={"col"}> </div>
                                            <div className={"col"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Communication with patients"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 1})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/patient.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Patient Communication</h5>

                                                        <br />

                                                    </div>

                                                </div>

                                            </div>
                                            <div className={"col"}>
                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Communication with patients"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 1})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/partner2.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Partner Communication</h5>

                                                        <br />

                                                    </div>

                                                </div>
                                            </div>
                                            <div className={"col"}> </div>

                                        </div>
                                    </>
                                )}
                                {state.subStep === 2 && (
                                    <>
                                        <div className={"row mt-4"}>

                                            <div className={"col-md-3"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima Targeted Appointments"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 3})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/planners.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Appointments</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>

                                            <div className={"col-md-3"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima Targeted Meetings"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 4})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/meetings.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Meetings</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>

                                            <div className={"col-md-3"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima Targeted Chats"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 5})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/messaging.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Chats</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>

                                            <div className={"col-md-3"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima Targeted Notifications"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 6})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/notifications.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Notifications</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>

                                            <div className={"col-md-3"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima Targeted Messages"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 7})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/unopened.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Messaging</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>

                                            <div className={"col-md-3"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima Targeted Documents Manager"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 8})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/notes.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Document Manager</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>

                                            <div className={"col-md-3"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima Healthcare Communications Center"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 0})
                                                    dispatch({type: "SET_STEP", payload: 0})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/back.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Go Back</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>


                                        </div>
                                    </>
                                )}

                                {state.subStep === 3 && (
                                    <>
                                        <div className={"row mt-4"}>

                                            <div className={"col"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima Patient Appointments"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 1})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/planners.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Patient Appointments</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>

                                            <div className={"col"}>

                                                <div className={"card card-animate"} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_HEADER", payload: "Uzima Patient Appointments"})
                                                    dispatch({type: "SET_SUB_STEP", payload: 1})
                                                }} >

                                                    <div className="card-body p-4 text-center">
                                                        <br />
                                                        <br />
                                                        <div className="mx-auto avatar-md mb-3">
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/planners.png`}
                                                                alt=""
                                                                className="img-fluid rounded-circle"
                                                            />
                                                        </div>
                                                        <br />
                                                        <h5 className="card-title mb-1">Partner Appointments</h5>

                                                        <br />

                                                    </div>

                                                </div>


                                            </div>

                                        </div>
                                    </>
                                )}
                            </>
                        )}

                        {state.step === 3 && (
                            <>
                                <div className={"row mt-4"}>
                                    <div className={"col"}>

                                        <div className={"card"} style={{"transition": "none"}}>

                                            <div style={{backgroundColor: "#577BC4", color: "white", fontSize: "15px", fontWeight: "Bold", transform: "none"}} className={"card-header d-flex justify-content-between align-items-center"}>
                                                <span>
                                                    {state.cardStep === 0 && (
                                                        <>
                                                            Create a General Web Meeting
                                                        </>
                                                    )}

                                                    {state.cardStep === 1 && (
                                                        <>
                                                            Choose Meeting Date
                                                        </>
                                                    )}

                                                    {state.cardStep === 2 && (
                                                        <>
                                                            Enter Meeting Details
                                                        </>
                                                    )}

                                                    {state.cardStep === 3 && (
                                                        <>
                                                            Add meeting participants
                                                        </>
                                                    )}

                                                    {state.cardStep === 4 && (
                                                        <>
                                                            Verify and confirm Meeting
                                                        </>
                                                    )}
                                                </span>
                                                <img style={{maxHeight: "25px"}} onClick={(e)=>{
                                                    dispatch({type: "SET_SUB_STEP", payload: 0})
                                                    dispatch({type: "SET_STEP", payload: 0})

                                                }} src={`${process.env.PUBLIC_URL}/assets/images/close.png`} alt=""
                                                     className="img-fluid card-animate"/>

                                            </div>

                                            <div className={"card-body"}>

                                                {state.cardStep === 0 && (
                                                    <>
                                                        <p>Hello there!</p>
                                                        <p>I will help you set up a general meeting.</p>
                                                        <p>So what is a general meeting?</p>
                                                        <p>This kind of meeting is not tied to a specific patient, service or partner. Anyone you select can attend!</p>
                                                        <p>If this is the kind of meeting you want to set up then let's proceed!</p>
                                                    </>
                                                )}

                                                {state.cardStep === 1 && (

                                                    <>
                                                        <div className={"row mt-4"}>
                                                            <div className={"col"}>

                                                                <label>When do you want to have the meeting?</label>
                                                                <input type={"date"} onChange={(e)=>{
                                                                    dispatch({type:"SET_DATE", payload: e.currentTarget.value})
                                                                }} className={"form-control mt-3 mb-4"} />

                                                            </div>
                                                        </div>

                                                    </>
                                                )}

                                                {state.cardStep === 2 && (
                                                    <>
                                                        <div className={"row mt-4"}>
                                                            <div className={"col"}>

                                                                <label>What is the meeting title?</label>
                                                                <input type={"text"} onChange={(e)=>{
                                                                    dispatch({type:"SET_MEETING_TITLE", payload: e.currentTarget.value})
                                                                }} className={"form-control mt-3 mb-1"} />

                                                            </div>
                                                        </div>

                                                        <div className={"row mt-4"}>
                                                            <div className={"col"}>

                                                                <label>Describe the meeting</label>
                                                                <input type={"text"} onChange={(e)=>{
                                                                    dispatch({type:"SET_MEETING_DESC", payload: e.currentTarget.value})
                                                                }} className={"form-control mt-3 mb-1"} />

                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {state.cardStep === 3 && (
                                                    <>

                                                        <div className={"row mt-2"}>
                                                            <div className={"col"}>

                                                                <label>How many participants do you intend to have (<em>Apart from you.</em>)?</label>
                                                                <select className={"form-control"}>
                                                                    <option>Choose One</option>
                                                                    <option>1</option>
                                                                    <option>2</option>
                                                                    <option>3</option>
                                                                    <option>4</option>
                                                                    <option>5</option>
                                                                    <option>6</option>
                                                                    <option>7</option>
                                                                    <option>8</option>
                                                                    <option>9</option>
                                                                    <option>10</option>
                                                                </select>

                                                            </div>
                                                        </div>

                                                    </>
                                                )}

                                            </div>

                                            <div className={"card-footer"}>

                                                {state.cardStep === 0 && (
                                                    <>
                                                        <div className={"row mt-2"}>
                                                            <div className={"col"}>

                                                                <button style={{width: "100%"}} onClick={(e)=>{
                                                                    dispatch({type:"SET_CARD_STEP", payload: 1})
                                                                }} className={"btn btn-primary"}>
                                                                    Okay, Let's Proceed.
                                                                </button>

                                                            </div>

                                                            <div className={"col"}>

                                                            </div>

                                                            <div className={"col"}>

                                                                <button className={"btn btn-primary"} style={{width: "100%"}}>
                                                                    I will do it later.
                                                                </button>

                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {state.cardStep === 1 && (
                                                    <>

                                                        <div className={"row mt-2"}>
                                                            <div className={"col"}>

                                                                <button style={{width: "100%"}} onClick={(e)=>{
                                                                    dispatch({type:"SET_CARD_STEP", payload: 2})
                                                                }} className={"btn btn-primary"}>
                                                                    Next Step.
                                                                </button>

                                                            </div>

                                                            <div className={"col"}>

                                                                <button style={{width: "100%"}} onClick={(e)=>{
                                                                    dispatch({type:"SET_CARD_STEP", payload: state.cardStep-1})
                                                                }} className={"btn btn-primary"}>
                                                                    Previous Step.
                                                                </button>

                                                            </div>

                                                            <div className={"col"}>

                                                                <button className={"btn btn-primary"} onClick={(e)=>{
                                                                    dispatch({type:"SET_STEP", payload: 1})
                                                                }} style={{width: "100%"}}>
                                                                    Cancel Process.
                                                                </button>

                                                            </div>
                                                        </div>

                                                    </>
                                                )}

                                                {state.cardStep === 2 && (
                                                    <>
                                                        <div className={"row mt-2"}>
                                                            <div className={"col"}>

                                                                <button style={{width: "100%"}} onClick={(e)=>{
                                                                    dispatch({type:"SET_CARD_STEP", payload: 3})
                                                                }} className={"btn btn-primary"}>
                                                                    Next Step.
                                                                </button>

                                                            </div>

                                                            <div className={"col"}>

                                                                <button style={{width: "100%"}} onClick={(e)=>{
                                                                    dispatch({type:"SET_CARD_STEP", payload: state.cardStep-1})
                                                                }} className={"btn btn-primary"}>
                                                                    Previous Step.
                                                                </button>

                                                            </div>

                                                            <div className={"col"}>

                                                                <button className={"btn btn-primary"} onClick={(e)=>{
                                                                    dispatch({type:"SET_STEP", payload: 1})
                                                                }} style={{width: "100%"}}>
                                                                    Cancel Process.
                                                                </button>

                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                                
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </>
                        )}

                        {state.step === 4 && (
                            <>
                                {state.subStep === 0 && (
                                    <>
                                        <div className={"row mt-4"}>
                                            <div className={"col"}>

                                                <div className={"card card-animate"}>
                                                    <div className={"row mt-1 mb-1"}>
                                                        <div className={"col-md-2"}>

                                                        </div>

                                                        <div className={"col-md-8"}>

                                                        </div>

                                                        <div className={"col-md-2"}>

                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </>
                                )}

                            </>
                        )}

                        {/* Enhanced Telehealth Session Step */}
                        {state.step === 6 && activeTelehealthSession && (
                            <>
                                <div className={"row mt-4"}>
                                    <div className={"col-12"}>
                                        <div className="card">
                                            <div className="card-header d-flex justify-content-between align-items-center bg-primary text-white">
                                                <h5 className="mb-0">
                                                    <FontAwesomeIcon icon={faVideo} className="me-2" />
                                                    Live Telehealth Session
                                                </h5>
                                                <button 
                                                    className="btn btn-outline-light btn-sm"
                                                    onClick={() => {
                                                        setActiveTelehealthSession(null);
                                                        setActiveCollaboration(null);
                                                        dispatch({type: "SET_STEP", payload: 0});
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faCompress} className="me-1" />
                                                    End Session
                                                </button>
                                            </div>
                                            <div className="card-body p-0">
                                                <TelehealthInterface 
                                                    sessionId={activeTelehealthSession || undefined}
                                                    collaborationId={activeCollaboration || undefined}
                                                    onSessionEnd={() => {
                                                        setActiveTelehealthSession(null);
                                                        setActiveCollaboration(null);
                                                        dispatch({type: "SET_STEP", payload: 0});
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {/* Document Management Step */}
                        {state.step === 7 && activeCollaboration && (
                            <>
                                <div className={"row mt-4"}>
                                    <div className={"col-12"}>
                                        <div className="card">
                                            <div className="card-header d-flex justify-content-between align-items-center bg-info text-white">
                                                <h5 className="mb-0">
                                                    <FontAwesomeIcon icon={faFileMedical} className="me-2" />
                                                    Collaboration Documents
                                                </h5>
                                                <button 
                                                    className="btn btn-outline-light btn-sm"
                                                    onClick={() => {
                                                        setActiveCollaboration(null);
                                                        dispatch({type: "SET_STEP", payload: 0});
                                                    }}
                                                >
                                                    Back to Dashboard
                                                </button>
                                            </div>
                                            <div className="card-body p-0">
                                                <DocumentManagement 
                                                    collaborationId={activeCollaboration}
                                                    onClose={() => {
                                                        setActiveCollaboration(null);
                                                        dispatch({type: "SET_STEP", payload: 0});
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {/* Enhanced Telehealth Dashboard */}
                        {state.step === 8 && (
                            <>
                                <div className={"row mt-4"}>
                                    <div className={"col-12"}>
                                        <div className="card">
                                            <div className="card-header bg-danger text-white">
                                                <h5 className="mb-0">
                                                    <FontAwesomeIcon icon={faHeartbeat} className="me-2" />
                                                    Enhanced Telehealth Features
                                                </h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-6 mb-4">
                                                        <div className="card border-primary h-100">
                                                            <div className="card-body text-center">
                                                                <FontAwesomeIcon icon={faVideo} size="3x" className="text-primary mb-3" />
                                                                <h5>Active Sessions</h5>
                                                                <p className="text-muted">View and manage ongoing telehealth sessions</p>
                                                                <div className="mt-3">
                                                                    {telehealthSessions.filter(s => s.status === 'active').length > 0 ? (
                                                                        telehealthSessions.filter(s => s.status === 'active').map(session => (
                                                                            <div key={session.session_id} className="alert alert-success">
                                                                                <strong>{session.title}</strong><br />
                                                                                <small>{session.session_type} - {session.duration} minutes</small>
                                                                            </div>
                                                                        ))
                                                                    ) : (
                                                                        <p className="text-muted">No active sessions</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-4">
                                                        <div className="card border-success h-100">
                                                            <div className="card-body text-center">
                                                                <FontAwesomeIcon icon={faCalendarAlt} size="3x" className="text-success mb-3" />
                                                                <h5>Scheduled Sessions</h5>
                                                                <p className="text-muted">Upcoming telehealth appointments</p>
                                                                <div className="mt-3">
                                                                    {telehealthSessions.filter(s => s.status === 'scheduled').length > 0 ? (
                                                                        telehealthSessions.filter(s => s.status === 'scheduled').slice(0, 3).map(session => (
                                                                            <div key={session.session_id} className="alert alert-info">
                                                                                <strong>{session.title}</strong><br />
                                                                                <small>{new Date(session.scheduled_time).toLocaleDateString()}</small>
                                                                            </div>
                                                                        ))
                                                                    ) : (
                                                                        <p className="text-muted">No scheduled sessions</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="text-center mt-4">
                                                    <button 
                                                        className="btn btn-primary me-3"
                                                        onClick={() => dispatch({type: "SET_STEP", payload: 0})}
                                                    >
                                                        Back to Dashboard
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                    </div>

                </div>

            </div>

            <Canvas></Canvas>

            <DashboardFooter />

        </>
    )
}

export default CommunicationHome